module.exports = "/static/media/lineto-circular-bolditalic.b0541428.woff2";